/**
 * @class
 */
import Base from '@netx/core/lib/netx-model';

class Brand extends Base {
	/**
	 * @type {Netx.Rpc}
	 * @private
	 */
	get rpc() {
		return true;
	}

	/** @type {array} */
	get xhrTrackProgress() {
		return ['getLocations'];
	}

	/**
	 * @type {object}
	 */
	get xhrLoadingMessages() {
		return {
			getBranding: 'Loading brand',
		};
	}

	/**
	 * @type {object}
	 */
	get xhrLoadedMessages() {
		return {
			getBranding: 'Loaded brand',
		};
	}

	/** @property {object} brandGetArgs - Arguments for getting brand items */
	get brandGetArgs() {
		return {
			/** @property {object} brandGetArgs.logo - Arguments for getting brand logo */
			logo: {
				/** @property {object} brandGetArgs.logo.type - String to pass as type for brand logo */
				type: 'LOGO',
			},
		};
	}

	/**
	 * @property {object}  defaults - The default attribute values
	 */
	get defaults() {
		return {
			/** @property {string} defaults.logo - Brand logo */
			logo: '',
		};
	}

	/**
	 * RPC methods:
	 * @rpcs
	 */
	get methods() {
		return {
			/**
			 * @method
			 * @param {object} opts Request options
			 */
			read(opts) {
				const d = new $.Deferred();

				this.getLogo(opts).then((response) => {
					// RPC is now turning nulls into empty arrays?
					if (!response || _.isArray(response)) {
						return d.resolve();
					}

					// Make sure it is a real image
					const img = new Image();
					$(img)
						.on('load', () => {
							let logo;
							if (img.naturalWidth && img.naturalHeight) {
								logo = '/' + response + '?t=' + _.uniqueId(_.now());
							}
							d.resolve({
								logo: logo,
							});
						})
						.on('error', () => {
							d.resolve();
						});
					img.src = '/' + response;
				}, d.reject);

				return d.promise();
			},
			/**
			 * Get branding logo
			 * See logo endpoints
			 * @method
			 * @deprecated
			 * @param {object} opts Request options
			 */
			getLogo(opts) {
				return ['getBranding', this.brandGetArgs.logo];
			},
			/**
			 * Resets all branding logos
			 * @method
			 */
			resetBranding: ['resetBranding'],
			/**
			 * Set branding logo
			 * @method
			 * @param {string} logoName Name of uploaded file
			 * @param {number} logoMode Logo to update (2=dark, 4=light)
			 * @param {object} opts Request options
			 */
			setLogo(logoName, logoMode, opts) {
				return ['simpleBranding', logoName, logoMode];
			},
		};
	}

	/** @override */
	constructor(attrs = {}, opts = {}) {
		attrs.id = _.uniqueId('brand-');

		super(attrs, opts);

		/** @property {object} brandSetArgs - Arguments for setting brand items */
		this.brandSetArgs = {
			/** @property {number} brandSetArgs.logoMode - Mode for setting brand logo */
			logoMode: 2,
			/** @property {string} brandSetArgs.logoName - Filename for setting brand logo */
			logoName: '',
			...opts.brandSetArgs,
		};
	}

	/** @type {string} */
	static get __name__() {
		return 'Brand';
	}
}

export default Brand;
